import * as React from 'react'

import StudentNavbarItems from '../components/studentNavbarItems.tsx'

const StudentNavbarItemsAppClient = ({ name }) => <StudentNavbarItems name={name} />

export default StudentNavbarItemsAppClient
